import { MULTIPLEADD, REMOVEITEM } from "../cart/actionIdentifier";
import { ADDTOCART } from "./actionIdentifier";

//Initial State
const initialState = [
  {
    productId: "1908001",
    productTitle: "Asus Vivobook X515MA",
    productPrice: 35500,
    productStock: 5,
  },
  {
    productId: "1908002",
    productTitle: "Dell E1916HV 18.5 Inch ",
    productPrice: 9300,
    productStock: 12,
  },
  {
    productId: "1908003",
    productTitle: "Canon Eos 4000D 18MP",
    productPrice: 36500,
    productStock: 20,
  },
];

//reducer function
const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDTOCART:
    case MULTIPLEADD:
      const newState = state.map((singleProduct) => {
        if (singleProduct.productId === action.payload.id) {
          return {
            ...singleProduct,
            productStock: singleProduct.productStock - 1,
          };
        } else {
          return {
            ...singleProduct,
          };
        }
      });
      return newState;
    case REMOVEITEM:
      const removedFromCart = state.map((singleProduct) => {
        if (singleProduct.productId === action.payload.id) {
          return {
            ...singleProduct,
            productStock: singleProduct.productStock + 1,
          };
        } else {
          return {
            ...singleProduct,
          };
        }
      });
      return removedFromCart;
    default:
      return state;
  }
};

export default productReducer;
